import api from '@/api/index.js'

const operator_journey_stats_report = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_OPERATOR_JOURNEY_STATS_REPORT_LOADING: (state, loading) => {
      state.data = null;
      state.loading = loading;
    },
    SET_OPERATOR_JOURNEY_STATS_REPORT: (state, data) => {
      state.data = data
      state.loading = false
    },
    SET_OPERATOR_JOURNEY_STATS_REPORT_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    LoadOperatorJourneysStatsReport({commit}, query) {
      let reqQueryStr = `operator=${query.operatorId}&`;
      if (query.ignoreCache === true) {
        reqQueryStr += 'ignore-cache=t&'
      }
      if (query.period.year) {
        reqQueryStr += `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr += `from=${query.period.from}&to=${query.period.to}`
      }

      commit('SET_OPERATOR_JOURNEY_STATS_REPORT_LOADING', true);
      return api.get('operator-reports/journeys-stats?' + reqQueryStr)
        .then((response) => {
          commit('SET_OPERATOR_JOURNEY_STATS_REPORT_ERROR', null)
          commit('SET_OPERATOR_JOURNEY_STATS_REPORT', response)
        })
        .catch((error) => {
          commit('SET_OPERATOR_JOURNEY_STATS_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_OPERATOR_JOURNEY_STATS_REPORT_LOADING', false);
        })
    },
  }
}

export default operator_journey_stats_report
